module.exports = __webpack_public_path__ + "static/media/DribbleIcon.f6b17e30.svg";